<template>
    
</template>

<script>
const EVENTS = ['online', 'offline', 'load'];

export default {
    data: () => ({
        isOnline: navigator.onLine || false,
    }),

    created() {
        EVENTS.forEach((event) =>
            window.addEventListener(event, this.updateOnlineStatus),
        );
    },

    beforeDestroy() {
        EVENTS.forEach((event) =>
            window.removeEventListener(event, this.updateOnlineStatus),
        );
    },
    methods: {
        updateOnlineStatus() {
            axios.get('/ping')
                .then(({data}) => {
                    if(data === "PONG") {
                        this.isOnline = true;
                        this.$emit('changed', this.isOnline);
                    }
                }).catch((error) => {
                    if (! error.status || ! navigator.onLine) {
                        this.isOnline = false;
                        this.$emit('changed', this.isOnline);
                    }
                });
        },
    },
};
</script>